module.exports = __webpack_public_path__ + "img/103.17543488.jpg";